<template>
  <p class="level-item control has-icon lxm-search">
    <input class="input"
           type="text"
           v-model="value"
           :placeholder="placeholder"
           @click="inputClicked"
           @keyup.enter="submit"
           @input="inputted">
    <img class="lxm-search-icon"
         src="../../images/main/nav-search.png"
         @click="submit" />
  </p>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-search
    margin-bottom: 0 !important
    .input
      height: siz(25)
      line-height: siz(25)
      border: 0
      box-shadow: none
      background: white-line
      border-radius: siz(12.5)
      padding-left: siz(32) !important
      padding-right: siz(8)
      font-size: size-small
  .lxm-search-icon
    width: siz(11)
    height: siz(11)
    position: absolute
    top: siz(7)
    left: siz(12)
</style>

<script>
  export default {
    props: {
      placeholder: {
        type: String,
        default: '搜索'
      },
      twoLetters: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        value: ''
      }
    },
    methods: {
      inputClicked () {
        this.$emit('click')
      },
      submit () {
        this.$emit('submit', { value: this.value })
      },
      inputted () {
        this.$emit('input', { value: this.value })

        if (this.twoLetters && this.value.length >= 2) {
          this.submit()
        }
        if (!this.twoLetters) {
          this.submit()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmSearch.vue?5ed23fa0